// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"15c36554","328":"042374bb","453":"e2f9f088","632":"4da7bd1b","648":"a624875f","703":"0f98a83c","807":"cdb05378","966":"219b2bfb"}[chunkId] + ".chunk.js";
};